// Media Gallery block schema - Auto-scrolling photo gallery synced with profile photos
export const mediaGallerySchema = {
  type: 'media-gallery',
  label: 'Photo Gallery',
  description: 'Auto-scrolling photo gallery (synced with profile)',
  icon: 'Images',
  defaultContent: {
    heading: '',
    showAll: true,
    maxPhotos: 0, // 0 = unlimited
    autoScrollSpeed: 'normal', // 'slow' | 'normal' | 'fast'
    imageHeight: 'medium', // 'small' | 'medium' | 'large'
    gap: 'normal', // 'compact' | 'normal' | 'spacious'
    pauseOnHover: true,
    style: {},
  },
};
